




































import { HorizontalDocumentTabs } from '@/components/shared';
import DocumentViewer from '@/components/shared/DocumentViewer.vue';
import { BaseDocumentSearchModel, DocumentViewerConstants, DocumentViewerToolbarOptionsModel, StoreConstants } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { DocumentTabModel } from '@/services/GeneratedApi';
import { Search } from '@/types/constants/routes/search';

export default Vue.extend({
  name: 'DefaultDocumentView',
  props: {},
  data() {
    return {
      exportOptions: DocumentViewerConstants.WithoutAcquiringLockExportOptions,
      isTabExpanded: false,
      isLoading: true,
      hideThumbnails: true,
      tabsLoading: true,
      tabs: [] as DocumentTabModel[]
    };
  },
  computed: {
    ...mapGetters(StoreConstants.DocumentView.ModuleName, ['document']),
    ...mapGetters(StoreConstants.Search.ModuleName, [StoreConstants.Search.Getters.SearchResults]),
    ...mapGetters(StoreConstants.Navigation.ModuleName, [
      StoreConstants.Navigation.Getters.DocumentViewBackRoute,
      StoreConstants.Navigation.Getters.DocumentViewBackRouteLabel,
      StoreConstants.Navigation.Getters.DocumentViewBackRouteParams
    ]),
    backButtonText(this: any): string {
      const label = this[StoreConstants.Navigation.Getters.DocumentViewBackRouteLabel];
      return label ? `Back to ${label}` : 'Back';
    },
    documentViewerToolbarOptions(this: any): DocumentViewerToolbarOptionsModel {
      const options: DocumentViewerToolbarOptionsModel = {
        allowPageNavigation: true,
        allowPageDelete: true,
        allowDocumentDelete: true,
        showEditReferences: true,
        pageDeleteNotAllowedTooltip: '',
        documentDeleteNotAllowedTooltip: ''
      };
      return options;
    }
  },
  methods: {
    ...mapActions(StoreConstants.ApplicationDirty.ModuleName, [StoreConstants.ApplicationDirty.Actions.ResetApplicationDirtyState]),
    ...mapActions(StoreConstants.DocumentView.ModuleName, ['setDocumentSearchModel', 'retrieveDocumentActions', 'loadPage']),
    ...mapActions(StoreConstants.Navigation.ModuleName, [StoreConstants.Navigation.Actions.ClearDocumentViewBackRoute]),
    toggleThumbnails(this: any) {
      this.hideThumbnails = !this.hideThumbnails;
    },
    setTabsLoaded(this: any, value: boolean) {
      this.tabsLoading = value;
    },
    async navigateBack(this: any) {
      const backRoute = this[StoreConstants.Navigation.Getters.DocumentViewBackRoute];
      const backRouteParams = this[StoreConstants.Navigation.Getters.DocumentViewBackRouteParams];

      if (backRoute) {
        this[StoreConstants.Navigation.Actions.ClearDocumentViewBackRoute]();
        this.$router.push({ name: backRoute, params: backRouteParams || {} });
      } else {
        this.$router.push({ name: Search.Criteria.name });
      }
    },
    deleteDocument(this: any) {
      this.$router.push({ name: Search.Results.name, params: { refresh: true } });
    }
  },
  async mounted(this: any) {
    try {
      this.setDocumentSearchModel({
        cabinetId: this.$route.params.cabinetId,
        documentId: Number.parseInt(this.$route.params.documentId, 10)
      } as BaseDocumentSearchModel);
      this.retrieveDocumentActions();
      this.loadPage(1);
      this.tabs = await ApiConfiguration.apiWithErrorPage().documentTabs.documentTabsTabsDetail(Number.parseInt(this.$route.params.documentId, 10), this.$route.params.cabinetId);
    } finally {
      this.isLoading = false;
    }
  },
  components: { DocumentViewer, HorizontalDocumentTabs, LoadingSpinner }
});
